var _a, _b, _c;
const version = ((_c = (_b = (_a = window.OC) == null ? void 0 : _a.config) == null ? void 0 : _b.version) == null ? void 0 : _c.split(".")[0]) || "32";
const isLegacy32 = Number.parseInt(version) < 32;
export {
  isLegacy32 as i
};
//# sourceMappingURL=legacy-NU_qxPFK.mjs.map
